const getLocalAccessToken = () => {
  const user = JSON.parse(localStorage.getItem('admin-user') || '{}');
  return user?.accessToken;
};

const updateLocalAccessToken = (token) => {
  const user = JSON.parse(localStorage.getItem('admin-user') || '{}');
  user.accessToken = token;
  localStorage.setItem('admin-user', JSON.stringify(user));
};

const getUser = () => JSON.parse(localStorage.getItem('admin-user') || '{}');

const setUser = (user) => {
  localStorage.setItem('admin-user', JSON.stringify({ ...user, date: new Date() }));
};

const removeUser = () => {
  localStorage.removeItem('admin-user');
};

const TokenService = {
  getLocalAccessToken,
  updateLocalAccessToken,
  getUser,
  setUser,
  removeUser,
};

export default TokenService;
